import { Mark, mergeAttributes, RawCommands } from '@lumiform/tiptap-vue-2';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    color: {
      /**
       * Set the text color
       * @param color The color to set
       * @example editor.commands.setColor('red')
       */
      setColor: (color: string) => ReturnType;

      /**
       * Unset the text color
       * @example editor.commands.unsetColor()
       */
      unsetColor: () => ReturnType;
    };
  }
}

/**
 * Repacked "Color" extension from @tiptap/extension-color which uses "font" tag with "color" attribute.
 */
export default Mark.create({
  name: 'color',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: element => element.getAttribute('color') || null,
        renderHTML: attributes => {
          if (!attributes.color) {
            return {};
          }

          return {
            color: attributes.color,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'font[color]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['font', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands(): Partial<RawCommands> {
    return {
      setColor: (color: string) => ({ commands }) => commands.setMark(this.name, { color }),
      unsetColor: () => ({ commands }) => commands.unsetMark(this.name),
    };
  },
});
